module.exports = __webpack_public_path__ + "assets/img/btn-view-all-b37343f9.png";